function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .cms-image-gallery_svg__cms-image-gallery_svg__st0{fill:#231F20}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cms-image-gallery_svg__cms-image-gallery_svg__st0",
  d: "M22.1,24.1c2.5,0,4.5-2,4.5-4.5c0,0,0,0,0,0c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5 C17.6,22.1,19.6,24.1,22.1,24.1z M22.1,17.3c1.3,0,2.3,1,2.3,2.3c0,0,0,0,0,0c0,1.3-1,2.3-2.3,2.3s-2.3-1-2.3-2.3 C19.8,18.3,20.9,17.3,22.1,17.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cms-image-gallery_svg__cms-image-gallery_svg__st0",
  d: "M34.6,11.8h-0.7v-0.7c0-2.3-1.9-4.2-4.2-4.2h-0.7V6.2c0-2.3-1.9-4.2-4.2-4.2H5.6c0,0,0,0,0,0 C3.3,2,1.4,3.9,1.4,6.2v14.7c0,2.3,1.9,4.2,4.2,4.2h0.7v0.7c0,2.3,1.9,4.2,4.2,4.2h0.7v0.7c0,2.3,1.9,4.2,4.2,4.2h19.3 c2.3,0,4.2-1.9,4.2-4.2V16C38.8,13.7,36.9,11.8,34.6,11.8z M36.6,16v9.3l-2.3-2.8c-0.7-0.8-1.6-1.2-2.7-1.2c-1,0-2,0.5-2.7,1.3 l-4.2,5c-0.4,0.5-1.1,0.6-1.6,0.2l-2.9-2c-1.2-0.8-2.7-0.8-3.9,0l-2.9,2V16c0-1.1,0.9-2,2-2h19.3C35.7,14,36.6,14.9,36.6,16z  M5.6,22.9c-1.1,0-2-0.9-2-2V6.3c0-1.1,0.9-2,2-2h19.3c1.1,0,1.9,0.9,2,1.9v0.7H10.5c-2.3,0-4.2,1.9-4.2,4.2v11.8H5.6z M10.5,27.8 c-1.1,0-2-0.9-2-2V11.1c0-1.1,0.9-2,2-1.9h19.2c1.1,0,2,0.9,2,1.9v0.7H15.3c-2.3,0-4.2,1.9-4.2,4.2v11.8H10.5z M34.6,32.7H15.3 c-1.1,0-2-0.9-2-2v-0.2l4.2-2.8c0.4-0.3,1-0.3,1.4,0l2.9,2c1.5,1,3.5,0.7,4.6-0.7l4.2-5c0.2-0.3,0.6-0.5,1-0.5c0.4,0,0.7,0.2,1,0.4 l4,4.8v1.9C36.6,31.8,35.7,32.7,34.6,32.7z"
}));

function SvgCmsImageGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cms-image-gallery_svg__cms-image-gallery_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgCmsImageGallery;